import { Location } from '@angular/common';
import { Injectable, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DyTableColumn, DyTableConfig } from '@dynamics/model/dy-model';
import moment from 'moment';
import {
  CARD_TYPES,
  MAIN_PAYMENT_METHODS,
  MAIN_PAYMENT_METHODS_DROPDOWN,
  MODULES,
  PAYMENT_FREQUENCY,
  PAYMENT_MONTH_DAYS_WEEK,
  PAYMENT_WEEK_DAYS,
  PRACTICE_CONFIGURATION_PYMENT_TYPES,
  RESPONSE,
} from '../constants';
import {
  ClearentCustomer,
  CreteCronCommand,
  PatientSummary,
  PaymentPlan,
  PaymentPlanPatient,
  RoleMasterData,
  SchedulePayment,
  State,
  Token,
  TokenByExpDate,
  User,
} from '../models';
import { ConfirmationPopUpComponent } from '../modules/popups/confirmation-pop-up/confirmation-pop-up.component';
import { AssessmentComponent } from '../pages/components/practice-assessment/practice-assessment/assessment/create-edit-assessment/assessment/assessment.component';
import { LocalStorageService } from './local-storage.service';
import { PaymentPlanService } from './payments/payment-plan.service';
import { SharedService } from './shared.service';
import { SnackBarService } from './snack-bar.service';
import { PatientService } from './tenants/patient.service';
import { UserRoleService } from './user-role.service';
import { FREQUENCY_BY_ID, FREQUENCY_TYPE_ID, LOAD_TYPE_ID } from '../constants/pms-configuration.constant';
import { TOOLTIP_DISCRIPTION_MESSAGES } from '../constants/messages.constant';
@Injectable({
  providedIn: 'root',
})
export class UtilService {
  @ViewChild('childRef') childComponent!: AssessmentComponent;
  frequencies: any = PAYMENT_FREQUENCY;
  weekDays: any[] = PAYMENT_WEEK_DAYS;
  monthDaysWeeks: any[] = PAYMENT_MONTH_DAYS_WEEK;
  loggedInUser: User;
  menuList: any[] = [];
  accessMenuList: any[] = [];
  menuListByCustomerSubscription: any;
  userRoleDetails: RoleMasterData;
  subscribed: any;
  maxFileSizeMB = 5;
  maxFileSizeBytes = this.maxFileSizeMB * 1024 * 1024;

  constructor(
    private _location: Location,
    private _paymentPlanService: PaymentPlanService,
    private _snackBarService: SnackBarService,
    private _patientService: PatientService,
    private _localStorageService: LocalStorageService,
    private _sharedService: SharedService,
    private _roleMatserService: UserRoleService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  getFormControl(form: FormGroup, controlName: string) {
    return form.get(controlName) as FormControl
  }

  displayMaskedPhoneNumber(phoneNumber: string) {
    phoneNumber = phoneNumber?.trim() || '';
    return phoneNumber?.length === 10
      ? `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(
        3,
        6
      )}-${phoneNumber.substring(6, 10)}`
      : '';
  }

  sortDatasetsByTotal(chart: any) {
    const datasets = chart.data.datasets;

    // 1. Create array with total included
    const datasetsWithTotal = datasets.map((dataset: any) => {
      const total = dataset.data.reduce(
        (sum: number, val: number) => sum + val,
        0
      );
      return { ...dataset, _total: total }; // temp property for sorting
    });

    // 2. Sort by total descending
    datasetsWithTotal.sort((a: any, b: any) => a._total - b._total);

    // 3. Remove _total and assign back
    chart.data.datasets = datasetsWithTotal.map((ds: any) => {
      const { _total, ...rest } = ds;
      return rest;
    });

    return chart;
  }

  rolePermissionAuthGuardTabs(url: string) {
    this.loggedInUser = this._localStorageService.getLoggedInUser();
    if (this.loggedInUser.roleId) {
      const reqBody = {
        customerId: this.loggedInUser.customerId,
      };
      this.menuListByCustomerSubscription = this._localStorageService.getData(
        'menuListByCustomerSubscription'
      );
      if (
        !this.menuListByCustomerSubscription ||
        !this.menuListByCustomerSubscription.length
      ) {
        this._localStorageService.setData('menuListByCustomerSubscription', []);
        this.getDefaultMenuList(reqBody, url);
      } else {
        this.menuListByCustomerSubscription = this._localStorageService.getData(
          'menuListByCustomerSubscription'
        );
        if (
          this.menuListByCustomerSubscription &&
          this.menuListByCustomerSubscription.length > 0
        ) {
          if (url.startsWith('/payments/patients/')) {
            const isCheckedTodaysPatients = this._localStorageService.getData(
              'isCheckedTodaysPatients'
            );
            const isCheckedAllPatients = this._localStorageService.getData(
              'isCheckedAllPatients'
            );
            if (
              ![true, false].includes(isCheckedTodaysPatients) ||
              ![true, false].includes(isCheckedAllPatients)
            ) {
              const tabSettings = this.menuListByCustomerSubscription
                .find((x: any) => x.moduleName === 'Payments (Module)')
                ?.menus?.[0]?.children?.find(
                  (y: any) => y.menuName === 'Patients (Submenu)'
                )?.children;
              const isCheckedTodaysPatients =
                tabSettings?.find(
                  (x: any) => x.menuName === 'Today’s Patients (Tab)'
                )?.checked || false;
              const isCheckedAllPatients =
                tabSettings?.find(
                  (x: any) => x.menuName === 'All Patients (Tab)'
                )?.checked || false;
              if (!isCheckedTodaysPatients && !isCheckedAllPatients) {
                this.router.navigate(['/payments/patients']);
              }
            }
          }
        }
      }
    }
  }

  rolePermissionAuthGuard(url: string) {
    this.loggedInUser = this._localStorageService.getLoggedInUser();
    if (this.loggedInUser.roleId) {
      const reqBody = {
        practiceId: this.loggedInUser.practiceId,
      };
      this.menuListByCustomerSubscription = this._localStorageService.getData(
        'menuListByCustomerSubscription'
      );
      if (
        !this.menuListByCustomerSubscription ||
        !this.menuListByCustomerSubscription.length
      ) {
        this._localStorageService.setData('menuListByCustomerSubscription', []);
        this.getDefaultMenuList(reqBody, url);
      } else {
        this.menuListByCustomerSubscription = this._localStorageService.getData(
          'menuListByCustomerSubscription'
        );
        if (
          this.menuListByCustomerSubscription &&
          this.menuListByCustomerSubscription.length > 0
        ) {
          this.isAllowedFunctionality(url);
        }
      }
    }
  }

  isAllowedFunctionality(url: string) {
    let arrOfBooleans = this.menuListByCustomerSubscription.map(
      (x: any) =>
        x.moduleName
          ?.toString()
          ?.toLowerCase()
          .includes(url?.split('/')?.[1]?.replaceAll('-', ' ')) &&
        x.menus?.[0]?.checked &&
        x.menus?.[0].children.map(
          (y: any) =>
            y.displayText
              ?.toString()
              ?.toLowerCase()
              .replaceAll('-', ' ')
              .includes(url?.split('/')?.[2]?.replaceAll('-', ' ')) && y.checked
        )
    );
    let isAllowed = false;
    arrOfBooleans.forEach((x: any) => {
      if (x && x.length) {
        isAllowed = x.find((y: boolean) => y) ? true : false;
      }
    });
    if (
      (['payments'].includes(url?.split('/')?.[1]) &&
        ['payment-reports'].includes(url?.split('/')?.[2]) &&
        this.menuListByCustomerSubscription
          .find((x: any) =>
            x.moduleName
              ?.toString()
              ?.toLowerCase()
              .includes(url?.split('/')?.[1]?.replaceAll('-', ' '))
          )
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'Payments Reports'
          ) &&
        this.menuListByCustomerSubscription.find((x: any) =>
          x.moduleName
            ?.toString()
            ?.toLowerCase()
            .includes(url?.split('/')?.[1]?.replaceAll('-', ' '))
        ).menus?.[0]?.checked &&
        this.menuListByCustomerSubscription
          .find((x: any) =>
            x.moduleName
              ?.toString()
              ?.toLowerCase()
              .includes(url?.split('/')?.[1]?.replaceAll('-', ' '))
          )
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'Payments Reports'
          ).checked) ||
      (['payment-plan'].includes(url?.split('/')?.[1]) &&
        ['payment-reports'].includes(url?.split('/')?.[2]) &&
        this.menuListByCustomerSubscription
          .find((x: any) =>
            x.moduleName
              ?.toString()
              ?.toLowerCase()
              .includes(url?.split('/')?.[1]?.replaceAll('-', ' '))
          )
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'Payment Plan Reports'
          ) &&
        this.menuListByCustomerSubscription.find((x: any) =>
          x.moduleName
            ?.toString()
            ?.toLowerCase()
            .includes(url?.split('/')?.[1]?.replaceAll('-', ' '))
        ).menus?.[0]?.checked &&
        this.menuListByCustomerSubscription
          .find((x: any) =>
            x.moduleName
              ?.toString()
              ?.toLowerCase()
              .includes(url?.split('/')?.[1]?.replaceAll('-', ' '))
          )
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'Payment Plan Reports'
          ).checked) ||
      (['ar-automation'].includes(url?.split('/')?.[1]) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        ) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        )?.menus?.[0]?.checked &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Automation Dashboard'
          ) &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Automation Dashboard'
          )?.checked) ||
      (['ar-automation'].includes(url?.split('/')?.[1]) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        ) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        )?.menus?.[0]?.checked &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Details'
          ) &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find((c: any) => c.menuName === 'A/R Details')
          ?.checked) ||
      (['ar-automation'].includes(url?.split('/')?.[1]) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        ) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        )?.menus?.[0]?.checked &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Automation Campaign'
          ) &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Automation Campaign'
          )?.checked) ||
      (['ar-automation'].includes(url?.split('/')?.[1]) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        ) &&
        this.menuListByCustomerSubscription.find(
          (x: any) => x.moduleName === 'A/R Automation'
        )?.menus?.[0]?.checked &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Automation Reports'
          ) &&
        this.menuListByCustomerSubscription
          .find((x: any) => x.moduleName === 'A/R Automation')
          ?.menus?.[0]?.children.find(
            (c: any) => c.menuName === 'A/R Automation Reports'
          )?.checked)
    ) {
      isAllowed = true;
    }
    if (!isAllowed) {
      let allowedMenu = this.menuListByCustomerSubscription.find(
        (x: any) => x.menus?.[0]?.checked
      );
      if (allowedMenu?.moduleName === 'Payments') {
        isAllowed = true;
        this.router.navigateByUrl('/payments/patients');
      } else if (allowedMenu?.moduleName === 'Payment Plan') {
        isAllowed = true;
        this.router.navigateByUrl('/payment-plan/payment-plan');
      } else if (allowedMenu?.moduleName === 'A/R Automation') {
        isAllowed = true;
        this.router.navigateByUrl('/ar-automation/ar-details');
      } else if (allowedMenu?.moduleName === 'Practice Analytics') {
        isAllowed = true;
        this.router.navigateByUrl('/practice-analytics/kpi-dashboard');
      } else if (allowedMenu?.moduleName === 'Practice Assessment') {
        isAllowed = true;
        this.router.navigateByUrl('/practice-assessment/practice-assessment');
      } else {
        isAllowed = true;
        this.router.navigateByUrl('/practice/all-practice');
      }
      // this.router.navigateByUrl('/other/forbidden');
    }
  }

  getDefaultMenuList(reqBody: any, url: string) {
     if (
        !reqBody ||
        reqBody.customerId === undefined ||
        reqBody.customerId === null ||
        reqBody.customerId === ''
      ) {
        return;
      }

    this._roleMatserService
      .GetMenuListByCustomerSubscription(reqBody)
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.menuList = res.data;
          this.groupMenusByModule(
            this.menuList,
            this.userRoleDetails,
            this.menuListByCustomerSubscription
          );
          if (this.menuList && this.menuList.length > 0) {
            this.getRoleMasterByMember(url);
          } else {
            this.isAllowedFunctionality(url);
          }
        }
      });
  }

  getRoleMasterByMember( url: string) {
    this.subscribed?.unsubscribe();
    this.subscribed = this._roleMatserService
      .GetRoleMasterByMember()
      .subscribe((res: any) => {
        if (res.isSuccess) {
          this.userRoleDetails = res.data;
          this.accessMenuList = this.userRoleDetails.roleDetails.map(
            (data: any) => {
              return {
                moduleId: data.moduleId,
                menuId: data.menuId,
                parentId: data.parentId,
              };
            }
          );
          this.menuListByCustomerSubscription = this.groupMenusByModule(
            this.menuList,
            this.userRoleDetails,
            this.menuListByCustomerSubscription
          );
          this._localStorageService.setData(
            'menuListByCustomerSubscription',
            this.menuListByCustomerSubscription
          );
          if (
            this.menuListByCustomerSubscription &&
            this.menuListByCustomerSubscription.length > 0
          ) {
            this.isAllowedFunctionality(url);
          }
        }
      });
  }

  displayAddressFormat(
    address: string,
    address2: any,
    city: string,
    state: string,
    zip: string
  ) {
    return [address, address2, city, state, zip].filter((x) => x).join(', ');
  }

  updateFormControlValue(event: any, formGroup: FormGroup<any>) {
    formGroup.get(event.source._id)?.setValue(event.source._value);
  }

  updateFormControlValueByField(
    event: any,
    formGroup: FormGroup<any>,
    fieldName: string,
    value: any
  ) {
    formGroup.get(fieldName)?.setValue(value);
  }

  generateDropdownValuesFromEnum(enumValues: any) {
    const formattedValues = Object.entries(enumValues).map(([value, name]) => ({
      name: name,
      value: value,
    }));
    return formattedValues;
  }

  prepareFormData(
    body: any,
    fileKey?: string,
    file?: File | null,
    fileKey2?: string,
    file2?: File | null
  ) {
    let formData: FormData = new FormData();
    fileKey && file && file?.name && formData.append(fileKey, file, file?.name);
    fileKey2 &&
      file2 &&
      file2?.name &&
      formData.append(fileKey2, file2, file2?.name);
    Object.keys(body).forEach((key) => {
      formData.append(key, body[key]);
    });
    return formData;
  }

  convertTime24To12(time24: string) {
    const timeParts = time24?.split(':');
    const hours = Number(timeParts?.[0]);
    const minutes = Number(timeParts?.[1]);
    const seconds = Number(timeParts?.[2].split('.')?.[0]);
    const time = new Date();
    time.setHours(hours);
    time.setMinutes(minutes);
    time.setSeconds(seconds);
    return time;
  }

  transform24to12AMPM(value: string): string {
    if (!value) return '';
    const [hourStr, minute] = value.split(':');
    let hour = parseInt(hourStr, 10);
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12;
    hour = hour ? hour : 12; // hour '0' should be '12'
    return `${hour}:${minute} ${ampm}`;
  }

  transform12to24(value: string): string {
    if (!value) return '';
    const [time, modifier] = value.trim().split(' ');
    if (!time || !modifier) return value;
    let [hours, minutes] = time.split(':').map(Number);

    if (modifier.toUpperCase() === 'PM' && hours !== 12) {
      hours += 12;
    }
    if (modifier.toUpperCase() === 'AM' && hours === 12) {
      hours = 0;
    }
    const hh = hours.toString().padStart(2, '0');
    const mm = minutes.toString().padStart(2, '0');

    return `${hh}:${mm}:00`;
  }

  copyMessage(val: string) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
  }

  isMinDate(dateString: string): boolean {
    return (
      !dateString ||
      dateString.startsWith('0001-01-01') ||
      dateString.startsWith('01/01/2001')
    );
  }

  formatDate(dateString: string): string {
    if (!dateString) return '-';
    if (typeof dateString == 'string' && dateString.indexOf('-') > -1) {
      return `
      ${dateString.split('-')[1]}/${dateString.split('-')[2]}/${dateString.split('-')[0]
        }
      `;
    }
    return dateString || '-';
  }

  parseAsLocalDate(dateInput: string | Date | null): Date {
    if (!dateInput) {
      return new Date(); // fallback to today if null
    }

    if (dateInput instanceof Date) {
      // If it's already a Date, strip the time part
      return new Date(
        dateInput.getFullYear(),
        dateInput.getMonth(),
        dateInput.getDate()
      );
    }

    // If it's a string like '2017-01-01'
    const [year, month, day] = dateInput.split('-').map(Number);
    return new Date(year, month - 1, day); // JS months are 0-based
  }

  formatDateAndTime(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    const month = isNaN(date.getMonth())
      ? '00'
      : (date.getMonth() + 1).toString().padStart(2, '0');
    const day = isNaN(date.getDate())
      ? '00'
      : date.getDate().toString().padStart(2, '0');
    const year = isNaN(date.getFullYear())
      ? '0000'
      : date.getFullYear().toString().padStart(4, '0');

    const hours = isNaN(date.getHours())
      ? '00'
      : date.getHours().toString().padStart(2, '0');
    const minutes = isNaN(date.getMinutes())
      ? '00'
      : date.getMinutes().toString().padStart(2, '0');
    const seconds = isNaN(date.getSeconds())
      ? '00'
      : date.getSeconds().toString().padStart(2, '0');

    return `${month}/${day}/${year}` &&
      `${month}/${day}/${year}` !== '00/00/0000'
      ? `${month}/${day}/${year} ${hours}:${minutes}:${seconds}`
      : '';
  }

  formatDateTommddyyy(dateString: string): string {
    const date = new Date(dateString);
    const month = isNaN(date.getMonth())
      ? '00'
      : (date.getMonth() + 1).toString().padStart(2, '0');
    const day = isNaN(date.getDate())
      ? '00'
      : date.getDate().toString().padStart(2, '0');
    const year = isNaN(date.getFullYear())
      ? '0000'
      : date.getFullYear().toString().padStart(4, '0');
    return `${month}/${day}/${year}`;
  }

  formatDateToMMDDYYYY(dateString: Date | string | null | undefined): string {
    const date = new Date(dateString?.toString() || '');
    const month = isNaN(date.getMonth())
      ? '00'
      : (date.getMonth() + 1).toString().padStart(2, '0');
    const day = isNaN(date.getDate())
      ? '00'
      : date.getDate().toString().padStart(2, '0');
    const year = isNaN(date.getFullYear())
      ? '0000'
      : date.getFullYear().toString().padStart(4, '0');
    return `${month}-${day}-${year}`;
  }

  parseMMDDYYYYToDate(dateString: string): Date {
    const [month, day, year] = dateString.split('-').map(Number);
    return new Date(year, month - 1, day);
  }


  formatClearantDate(dateString: Date | string | null | undefined): string {
    const date = new Date(dateString?.toString() || '');
    const month = isNaN(date.getMonth())
      ? '00'
      : (date.getMonth() + 1).toString().padStart(2, '0');
    const day = isNaN(date.getDate())
      ? '00'
      : date.getDate().toString().padStart(2, '0');
    const year = isNaN(date.getFullYear())
      ? '0000'
      : date.getFullYear().toString().padStart(4, '0');
    return `${year}-${month}-${day}`;
  }

  // formatDateToMMDDYYYY(dateString: string | null | undefined): string {
  //   if (dateString?.includes('-')) {
  //     return `
  //     ${dateString.split('-')[1]}/${dateString.split('-')[2]}/${
  //       dateString.split('-')[0]
  //     }
  //     `;
  //   }
  //   return dateString || '-';
  // }

  formatDateOnly(dateValue: any): string {
    if (!dateValue) return '';

    // Take only the date part before 'T'
    const datePart = dateValue.split('T')[0]; // "2025-08-11"
    const [year, month, day] = datePart.split('-');

    return `${month}/${day}/${year}`;
  }

  interleaveTextArray(arr: any) {
    const half = arr.length / 2;
    const result = [];
    for (let i = 0; i < half; i++) {
      result.push(arr[i], arr[i + half]);
    }
    return result;
  }

  isInvalidDate(date: any): boolean {
    return !(date instanceof Date) || isNaN(date.getTime());
  }

  showDate(date: any) {
    return date?.toString()?.split('T')[0] || '';
  }

  focusSection(id: string) {
    document.getElementById(id)?.click();
  }

  increment(
    event: any,
    formGroup: FormGroup<any>,
    fieldName: string,
    max: number
  ) {
    let value = Number(formGroup.get(fieldName)?.value);
    if (!max || value < max) {
      formGroup.get(fieldName)?.setValue(value + 1);
    }
  }

  decrement(
    event: any,
    formGroup: FormGroup<any>,
    fieldName: string,
    min: number
  ) {
    let value = Number(formGroup.get(fieldName)?.value);
    if (value > min) {
      formGroup.get(fieldName)?.setValue(value - 1);
    }
  }

  tokensByExpDate(tokens: Token[]): TokenByExpDate {
    let tokensByExpDate = new TokenByExpDate();
    tokens.forEach((x) => {
      if (x.tokenType == 1 && x.expDate && x.expDate.length == 4) {
        const expDateMonth = Number(x.expDate?.slice(0, 2)) - 1;
        const expDateYear = 2000 + Number(x.expDate?.slice(2, 4));
        const expDate = moment({
          year: expDateYear,
          month: expDateMonth,
        }).endOf('month');
        const expired = moment(expDate).diff(moment(), 'months', true) < 0;
        const expiringSoon =
          moment(expDate).diff(moment(), 'months', true) <= 1 &&
          moment(expDate).diff(moment(), 'months', true) >= 0;
        if (expired) {
          tokensByExpDate.expired.push(x);
        } else if (expiringSoon) {
          tokensByExpDate.expiringSoon.push(x);
        } else {
          tokensByExpDate.active.push(x);
        }
      }
      if (x.tokenType == 2) {
        if (x.isActive) {
          tokensByExpDate.active.push(x);
        } else {
          tokensByExpDate.expired.push(x);
        }
      }
    });
    return tokensByExpDate;
  }

  setPaymentMethodConfiguration(doNotProcess?: any) {
    let paymentMethods = MAIN_PAYMENT_METHODS;
    let arrConfig: any = [];
    if (doNotProcess && doNotProcess.length) {
      doNotProcess.map((data: any) => {
        if (
          data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.PHYSICAL_TERMINAL
        ) {
          arrConfig.push({
            name: paymentMethods.PHYSICAL_TERMINAL,
            disabled: data.isEnable,
          });
        } else if (
          data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.VIRTUAL_TERMINAL
        ) {
          arrConfig.push({
            name: paymentMethods.VIRTUAL_TERMINAL,
            disabled: data.isEnable,
          });
        } else if (
          data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.PAYMENT_LINK
        ) {
          arrConfig.push({
            name: paymentMethods.PAYMENT_LINK,
            disabled: data.isEnable,
          });
        } else if (
          data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.ACH_OR_E_CHECK
        ) {
          arrConfig.push({
            name: paymentMethods.ACH_OR_E_CHECK,
            disabled: data.isEnable,
          });
        } else if (data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.CHECK) {
          arrConfig.push({
            name: paymentMethods.CHECK,
            disabled: data.isEnable,
          });
        } else if (data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.CASH) {
          arrConfig.push({
            name: paymentMethods.CASH,
            disabled: data.isEnable,
          });
        } else if (
          data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.PAYMENT_PLAN
        ) {
          arrConfig.push({
            name: paymentMethods.PAYMENT_PLAN,
            disabled: data.isEnable,
          });
        } else if (data.name == PRACTICE_CONFIGURATION_PYMENT_TYPES.SAVED_CARD) {
          arrConfig.push({
            name: paymentMethods.SAVED_CARD,
            disabled: data.isEnable,
          });
        }
      });
      return arrConfig;
    } else {
      return [
        {
          name: paymentMethods.SAVED_CARD,
          disabled: true,
        },
        {
          name: paymentMethods.PHYSICAL_TERMINAL,
          disabled: true,
        },
        {
          name: paymentMethods.VIRTUAL_TERMINAL,
          disabled: true,
        },
        {
          name: paymentMethods.PAYMENT_LINK,
          disabled: true,
        },
        {
          name: paymentMethods.ACH_OR_E_CHECK,
          disabled: true,
        },
        {
          name: paymentMethods.CHECK,
          disabled: true,
        },
        {
          name: paymentMethods.CASH,
          disabled: true,
        },
        {
          name: paymentMethods.PAYMENT_PLAN,
          disabled: true,
        },
      ];
    }
  }

  getPaymentMethodConfiguration(
    paymentMethodConfiguration: any[],
    name: string
  ) {
    return !paymentMethodConfiguration?.find((x) => x.name === name)?.disabled;
  }

  goBack(
    practiceId?: number,
    patientId?: number,
    paymentPlanId?: number,
    clickedTab?: string
  ) {
    let isAny = false;
    if (
      (this._location
        .path()
        .startsWith(
          '/practice-assessment/practice-assessment/create-edit-assessment/assessment/'
        ) ||
        ((this._location.path().startsWith('/payment-plan/payment-plan/') ||
          this._location.path().startsWith('/payments/patients/')) &&
          this._location.path().includes('/edit-payment-plan/') &&
          this._location.path().endsWith('/payment-plan')) ||
        ((this._location.path().startsWith('/payment-plan/payment-plan/') ||
          this._location.path().startsWith('/payments/patients/')) &&
          this._location.path().includes('/edit-payment-plan/') &&
          this._location.path().endsWith('/adjust-plan')))
    ) {
          localStorage.setItem('isAnyFormDirty', 'false');
          this._sharedService.setFormDirty(false);
          if (
            ((this._location.path().startsWith('/payment-plan/payment-plan/') ||
              this._location.path().startsWith('/payments/patients/')) &&
              this._location.path().includes('/edit-payment-plan/') &&
              this._location.path().endsWith('/payment-plan')) ||
            ((this._location.path().startsWith('/payment-plan/payment-plan/') ||
              this._location.path().startsWith('/payments/patients/')) &&
              this._location.path().includes('/edit-payment-plan/') &&
              this._location.path().endsWith('/adjust-plan'))
          ) {
            if (clickedTab && practiceId && patientId && paymentPlanId) {
              this.router.navigate([
                `/payment-plan/payment-plan/${practiceId}/${patientId}/edit-payment-plan/${paymentPlanId}/${clickedTab}`,
              ]);
            } else {
              this.router.navigate(['/payment-plan/payment-plan']);
            }
            localStorage.setItem('isAnyFormDirty', 'false');
            this._sharedService.setFormDirty(false);
          } else {
            this._location.back();
          }
      return;
    }

    const previousUrl = this._localStorageService.getData('previousUrl');
    if (
      this._location.path().startsWith('/payments/patients/') &&
      (this._location.path().endsWith('/billing-summary') ||
        this._location.path().endsWith('/dos-view') ||
        this._location.path().endsWith('/payment-method') ||
        this._location.path().endsWith('/pre-payment') ||
        this._location.path().endsWith('/payment-plan') ||
        this._location.path().endsWith('/transaction-history')) &&
      previousUrl
    ) {
      if (previousUrl.includes('/ar-automation/ar-details') && !previousUrl.includes('/view-payor-list')) {
        this.router.navigate(['/ar-automation/ar-details']);
        this._localStorageService.removeData('previousUrl');
        return;
      }
      if (previousUrl.includes('/ar-automation/ar-details/view-payor-list/')) {
        const payorId = previousUrl.split('/view-payor-list/')[1];
        this.router.navigate([`/ar-automation/ar-details/view-payor-list/${payorId}`]);
        this._localStorageService.removeData('previousUrl');
        return;
      }
    }

    const patientChildRoutes = [
      '/billing-summary',
      '/dos-view',
      '/payment-method',
      '/pre-payment',
      '/payment-plan',
      '/failed-payment',
      '/transaction-history',
      //'/take-payment',
    ];
    const practiceChildRoutes = [
      '/account-details',
      '/agreement-cc',
      '/pms-configuration',
      '/processor-setting',
      '/payment-method',
      '/user',
      '/user-roles',
      '/carrier-master',
      '/carrier-plan-master',
      '/carrier-mapping',
      '/subscriptions',
      '/terminal-setup',
    ];
    const paymentPlanChildRoutes = [
      '/payment-plan',
      '/adjust-plan',
      '/transaction-history',
    ];
    if (this._location.path().startsWith('/ar-automation/ar-details/view-payor-list/')) {
      this.router.navigate(['/ar-automation/ar-details']);
      isAny = true;
      return;
    }
    patientChildRoutes.forEach((item) => {
      if (
        this._location.path().startsWith('/payments/patients/') &&
        this._location.path().endsWith(item)
      ) {
        this.router.navigate(['/payments/patients']);
        isAny = true;
      }
    });
    if (
      this._location.path().startsWith('/payment-plan/payment-plan/') &&
      this._location.path().includes('/create-payment-plan/') &&
      this._location.path().endsWith('/direct')
    ) {
      if (
          previousUrl &&
          previousUrl.startsWith('/payments/patients/') &&
          previousUrl.endsWith('/payment-plan')
        ) {
          this.router.navigateByUrl(previousUrl);
        } else {
          this.router.navigate(['/payment-plan/payment-plan']);
        }
       isAny = true;
    }
    if (
      this._location.path().startsWith('/payment-plan/payment-plan/') &&
      this._location.path().includes('/create-payment-plan/') &&
      this._location.path().endsWith('/inital') &&
      practiceId &&
      patientId
    ) {
      this.router.navigate([
        `/payments/patients/${practiceId}/${patientId}/billing-summary`,
      ]);
      isAny = true;
    }
    paymentPlanChildRoutes.forEach((item) => {
      if (
        this._location.path().startsWith('/payment-plan/payment-plan/') &&
        this._location.path().includes('/edit-payment-plan/') &&
        this._location.path().endsWith(item)
      ) {
        this.router.navigate(['/payment-plan/payment-plan']);
        isAny = true;
      }
    });
    practiceChildRoutes.forEach((item) => {
      if (this._location.path().startsWith(`/practice/all-practice${item}`)) {
        this.router.navigate(['/practice/all-practice']);
        isAny = true;
      }
    });
    if (!isAny) {
      if (this._sharedService.getIsFormDirtyValue())
      {
        let dialogRef = this.dialog.open(ConfirmationPopUpComponent, {
          height: '220px',
          width: '600px',
          disableClose: true,
          data: {
            mainTitle: 'Discard Changes',
            subTitle: 'There are unsaved changes. Are you sure you want to discard all changes?',
            saveText: 'Discard'
          }
        });
        dialogRef.afterClosed().subscribe((response) => {
          if (response === 'confirm') {
            this._sharedService.setIsFormDirty(false);
            this._location.back();
          }
          else
          {
            return;
          }
        });
      }
      else{
        this._location.back();
      }
    }
  }

  getNextDayOfWeek(startDate: Date, dayOfWeek: number): Date {
    let resultDate = startDate;
    let daysToAdd = (dayOfWeek + 7 - resultDate.getDay()) % 7;
    if (daysToAdd === 0) {
      daysToAdd = 7;
    }
    resultDate.setDate(resultDate.getDate() + daysToAdd);
    return resultDate;
  }

  resetToStartOfUTCDay(dateStr: Date | string | null): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    // Set to 00:00:00.000 in UTC
    date.setUTCHours(0, 0, 0, 0);
    return date.toISOString(); // returns in ISO format with Z (UTC)
  }

  resetToEndOfUTCDay(dateStr: Date | string | null): string {
    if (!dateStr) return '';
    const date = new Date(dateStr);
    // Set to 23:59:59.999 in UTC
    date.setUTCHours(23, 59, 59, 999);
    return date.toISOString(); // returns in ISO format with Z (UTC)
  }

  getRelativeDate(startDate: Date, nthWeek: number, dayOfWeek: number) {
    let nextMonthStartDay = startDate;
    let resultDate = startDate;
    nextMonthStartDay.setDate(1);
    nextMonthStartDay.setMonth(nextMonthStartDay.getMonth() + 1);
    let daysToAdd =
      ((dayOfWeek + 7 - nextMonthStartDay.getDay()) % 7) +
      (nthWeek < 4 ? nthWeek : 3) * 7;
    let totalDaysInMonth = new Date(
      resultDate.getFullYear(),
      resultDate.getMonth() + 1,
      0
    ).getDate();
    resultDate.setDate(
      resultDate.getDate() +
      daysToAdd +
      (totalDaysInMonth - (resultDate.getDate() + daysToAdd) >= 7 ? 7 : 0)
    );
    return resultDate;
  }

  generateGUID() {
    return `${new Date().getTime()}-${Math.floor(Math.random() * 1000000)}`;
  }

  getAndSetClearentCustomer(patientId: number, body: ClearentCustomer) {
    this._paymentPlanService
      .getClearentCustomerByPatientId(patientId)
      .subscribe((response) => {
        if (response.isSuccess && !response.data) {
          this._paymentPlanService
            .createClearentCustomer(body)
            .subscribe((response) => {
              if (response.isSuccess) {
                this._snackBarService.openSnackBar(
                  response.message || RESPONSE[200],
                  'Success'
                );
              } else {
                this._snackBarService.openSnackBar(
                  response.message || RESPONSE[0],
                  'Error'
                );
              }
            });
        }
      });
  }

  useDefaultPatientAddress(
    event: any,
    billingInformationForm: any,
    practiceId: number,
    patientId: number,
    states: State[]
  ) {
    if (patientId && practiceId) {
      if (event.target.checked) {
        this._sharedService.setIsLoadingDefaultAddress(true);
        this._patientService
          .getPatientSummary({
            patientId,
            practiceId,
          })
          .subscribe((response) => {
            if (response.isSuccess) {
              billingInformationForm
                .get('address1')
                ?.setValue(
                  (response.data?.patientSummary?.address1?.trim() || '') +
                  (response.data?.patientSummary?.address1?.trim() &&
                    response.data?.patientSummary?.address2?.trim()
                    ? ', '
                    : '') +
                  (response.data?.patientSummary?.address2?.trim() || '')
                );
              billingInformationForm
                .get('city')
                ?.setValue(response.data?.patientSummary?.city);
              billingInformationForm
                .get('zip')
                ?.setValue(response.data?.patientSummary?.zipcode);
              billingInformationForm
                .get('country')
                ?.setValue(response.data?.patientSummary?.country);
              if (
                states
                  .map((x) => x.abbreviation)
                  ?.includes(response.data?.patientSummary?.state)
              ) {
                billingInformationForm
                  .get('state')
                  ?.setValue(response.data?.patientSummary?.state);
              } else {
                billingInformationForm.get('state')?.setValue('');
              }
            }
            this._sharedService.setIsLoadingDefaultAddress(false);
          });
        billingInformationForm.markAllAsTouched();
      }
    }
  }

  dashedPhoneFormat(phone: string) {
    return (
      phone[0] +
      phone[1] +
      phone[2] +
      '-' +
      phone[3] +
      phone[4] +
      phone[5] +
      '-' +
      phone[6] +
      phone[7] +
      phone[8] +
      phone[9]
    );
  }

  getCardTypeClass(cardType: string) {
    switch (cardType) {
      case CARD_TYPES.VISA:
        return 'visa-card';
      case CARD_TYPES.AMEX:
        return 'amex-card';
      case CARD_TYPES.MASTER:
        return 'master-card';
      default:
        return 'gray-card';
    }
  }

  textEllipsis(text: string, length: number) {
    return (
      text &&
      length &&
      text?.substring(0, length) + (text?.length > length ? '...' : '')
    );
  }

  applyTablePreferences(
    tablePreferences: any[],
    tableConfig: DyTableConfig,
    initialColumns: DyTableColumn[]
  ) {
    // hide/unhide and sequence of table columns logic functionality
    let sequencedData = tablePreferences
      ?.filter((x) => x.checked)
      .map((y) => y.name);
    tableConfig.columns = [];
    sequencedData.forEach((x) => {
      let dataColumn = initialColumns?.find((z) => z.label === x);
      dataColumn && tableConfig.columns.push(dataColumn);
    });
  }

  prepareTablePreferences(
    initialColumns: DyTableColumn[],
    tablePreferences: any[],
    storedTablePreferences: any,
    tableName: string,
    paginationFilter: any,
    pageState?: { pageSize: number; pageNumber: number }
  ): [tablePreferences: any[], paginationFilter: any] {
    tablePreferences =
      initialColumns?.map((x) => {
        return { checked: true, name: x.label };
      }) || [];
    storedTablePreferences =
      this._localStorageService.getTablePreferencesByTableName(tableName);
    if (storedTablePreferences?.pageSize) {
      paginationFilter.pageSize = storedTablePreferences?.pageSize;
    }
    // if (storedTablePreferences?.pageState?.pageSize) {
    //   paginationFilter.pageSize = storedTablePreferences?.pageState?.pageSize;
    // }
    if (storedTablePreferences?.pageState?.pageNumber) {
      paginationFilter.pageNumber =
        storedTablePreferences?.pageState?.pageNumber;
    }
    if (!storedTablePreferences) {
      this._localStorageService.setTablePreferences(
        tableName,
        tablePreferences,
        15, // default value is 5
        pageState
      );
    } else {
      // Reconcile the stored preference against the CURRENT column definitions instead of using
      // it as-is - a column whose code-defined label was renamed, or a brand-new column added
      // later, has no entry in an existing user's stored list and would otherwise be silently
      // dropped forever by applyTablePreferences' name-based lookup (matched this session, twice:
      // once for a renamed column, once for a newly added one).
      const currentLabels = new Set(initialColumns?.map((x) => x.label) || []);
      const storedValue = storedTablePreferences.value || [];
      const storedLabels = new Set(storedValue.map((x: any) => x.name));
      const reconciled = storedValue.filter((x: any) => currentLabels.has(x.name));
      (initialColumns || [])
        .filter((x) => !storedLabels.has(x.label))
        .forEach((x) => reconciled.push({ checked: true, name: x.label }));
      tablePreferences = reconciled;
      if (reconciled.length !== storedValue.length) {
        this._localStorageService.setTablePreferences(
          tableName,
          tablePreferences,
          storedTablePreferences.pageSize || 15,
          storedTablePreferences.pageState || pageState
        );
      }
    }
    return [tablePreferences, paginationFilter];
  }

  prepareBagdeLabel(row: any, cols: any) {
    if (row) {
      if (cols.dataKey === 'isActive') {
        if (row[cols.dataKey] === true) {
          return 'Active';
        }
        if (row[cols.dataKey] === false) {
          return 'Inactive';
        }
      }
      if (cols.dataKey === 'isSandbox') {
        if (row[cols.dataKey] === true) {
          return 'Sandbox';
        }
        if (row[cols.dataKey] === false) {
          return 'Production';
        }
      }
      if (cols.dataKey === 'isSuccess') {
        if (row[cols.dataKey] === true) {
          return 'Success';
        }
        if (row[cols.dataKey] === false) {
          return 'Failed';
        }
      }
      return row[cols.dataKey];
    }
  }

  prepareBadgeClass(row: any, cols: any) {
    if (cols.dataKey === 'isActive') {
      if (row[cols.dataKey] === true) {
        return 'badge badge-success';
      }
      if (row[cols.dataKey] === false) {
        return 'badge badge-danger';
      }
    }
    if (cols.dataKey === 'isSandbox') {
      if (row[cols.dataKey] === true) {
        return 'badge badge-success';
      }
      if (row[cols.dataKey] === false) {
        return 'badge badge-danger';
      }
    }
    if (cols.dataKey === 'isSuccess') {
      if (row[cols.dataKey] === true) {
        return 'badge badge-success';
      }
      if (row[cols.dataKey] === false) {
        return 'badge badge-danger';
      }
    }
    if (cols.dataKey === 'paymentPromotion') {
      if (row[cols.dataKey] === true) {
        return 'badge badge-success';
      }
      if (row[cols.dataKey] === false) {
        return 'badge badge-danger';
      }
    }
    return this.getStatusBadgeClass(row[cols.dataKey] || cols);
  }

  //#region Status
  public getStatusBadgeClass(status: string): string {
    switch (status) {
      case 'Active':
        return 'badge badge-success';
      case 'Inactive':
        return 'badge badge-danger';
      case 'Declined':
        return 'badge badge-danger';
      case 'Will be Declined':
        return 'badge badge-warning';
      case 'Fully Paid':
        return 'badge badge-success';
      case 'Paid':
        return 'badge badge-success';
      case 'Over Paid':
        return 'badge badge-danger';
      case 'Partially Paid':
        return 'badge badge-warning';
      case 'Unpaid':
        return 'badge badge-secondary';
      case 'Checked-In':
        return 'badge badge-primary';
      case 'Canceled':
        return 'badge badge-danger';
      case 'Unconfirmed':
        return 'badge badge-warning';
      case 'Confirmed':
        return 'badge badge-success';
      case 'No Show':
        return 'badge badge-info';
      case 'SUCCESS':
        return 'badge badge-success';
      case 'Success':
        return 'badge badge-success';
      case 'Failed':
        return 'badge badge-danger';
      case 'Pending':
        return 'badge badge-warning';
      case 'Denied':
        return 'badge badge-danger';
      case 'Not Submitted':
        return 'badge badge-warning';
      case 'Submitted':
        return 'badge badge-success';
      case 'Void':
        return 'badge badge-primary';
      case 'Refund':
        return 'badge badge-warning';
      case 'O':
        return 'badge badge-danger';
      case 'P':
        return 'badge badge-success';
      case 'success':
        return 'badge badge-success';
      case 'fail':
        return 'badge badge-danger';
      case 'Link Sent':
        return 'badge badge-secondary';
      case 'Mapped':
        return 'badge badge-success';
      case 'Unmapped':
        return 'badge badge-danger';
      case 'Posted':
        return 'badge badge-secondary';
      case 'Refunded':
        return 'badge badge-secondary';
      case 'Refund Failed':
        return 'badge badge-danger';
      case 'OverDue':
        return 'badge badge-danger';
      case 'Due':
        return 'badge badge-warning';
      case 'Voided':
        return 'badge badge-primary';
      case 'Completed':
        return 'badge badge-success';
      case 'Cancelled':
        return 'badge badge-danger';
      case 'Created':
        return 'badge badge-secondary';
      case 'Open':
        return 'badge badge-warning';
      case 'Closed':
        return 'badge badge-success';
      case 'Elec.':
        return 'badge badge-primary';
      case 'Print':
        return 'badge badge-info';
      case 'Deleted':
        return 'badge badge-danger';
      case 'Unsubmitted':
        return 'badge badge-secondary';
      case 'In Process':
        return 'badge badge-primary';
      case 'Recreated':
        return 'badge badge-warning';
      case 'Skipped':
        return 'badge badge-secondary';
      case 'Duplicate Transaction': 
        return 'badge badge-warning';
      case 'Invited':
        return 'badge badge-primary';
      case 'Expired':
        return 'badge badge-warning';
      default:
        return 'badge badge-danger';
    }
  }
  //#endregion
  public getWidgetClass(status: string): string {
    switch (status) {
      case 'Installed & Active':
        return 'badge badge-success';
      case 'Created & Not Active':
        return 'badge badge-warning';
      case 'Not Created & Not Active':
        return 'badge badge-danger';
      default:
        return '';
    }
  }

  newDate(date: string) {
    return new Date(date);
  }

  resetNote() {
    this._sharedService.setNote('');
    this._sharedService.setNoteSubject('');
  }

  preparePreviewPaymentPlan(
    form: FormGroup,
    paymentPlan: PaymentPlanPatient,
    frequency: string,
    schedulePaymentList: any[],
    adjustedPaymentList: any[],
    alreadyPaidSchedulePaymentList: any[],
    durationOrAmount: string,
    failedPaymentList: any[] = []
  ) {
    let editPaymentFormValues = form.value;
    let previewPaymentPlan = {
      paymentPlanId: paymentPlan.paymentPlanId,
      name: editPaymentFormValues.planName || paymentPlan.planName,
      templateId: paymentPlan.paymentPlanTemplateId,
      templateName: paymentPlan.templateName || '',
      totalAmount: paymentPlan.totalAmount,
      paymentPlanAmt: paymentPlan.totalAmount,
      todayAmountType: editPaymentFormValues.todayAmountType,
      percentage: editPaymentFormValues.percentage,
      todayPaymentAmt: paymentPlan.initialAmount,
      remainingPaymentPlanAmt: paymentPlan.remainingAmount,
      remainingPatientPortion: paymentPlan.remainingAmount,
      frequency: frequency || paymentPlan.frequency,
      installmentAmount:
        Number(
          Number(editPaymentFormValues.installmentAmount || 0).toFixed(2) || 0
        ) || Number(Number(paymentPlan?.installment || 0).toFixed(2) || 0),
      duration: Number(
        editPaymentFormValues.duration || paymentPlan?.noOfInstallments || 0
      ),
      startingDate:
        this.formatClearantDate(
          editPaymentFormValues.startDate ||
          this.formatDate(new Date().toString())
        ) || paymentPlan.startDate,
      primaryTokenId: editPaymentFormValues.primaryCard,
      primaryMethod: editPaymentFormValues.primaryCardType,
      primaryCard: editPaymentFormValues.primaryCardNumber,
      primaryCardType: editPaymentFormValues.primaryCardGroup,
      secondaryTokenId: editPaymentFormValues.secondaryCard,
      secondaryMethod: editPaymentFormValues.secondaryCardType,
      secondaryCard: editPaymentFormValues.secondaryCardNumber,
      secondaryCardType: editPaymentFormValues.secondaryCardGroup,
      signedContractPath: paymentPlan.signedContractPath,
      schedulePaymentList,
      adjustedPaymentList,
      alreadyChargedSchedulePaymentList: alreadyPaidSchedulePaymentList,
      // Task 3592: the failed payments the plan page lists, so the print shows them too.
      failedPaymentList,
      paymentPlanIndividualName: paymentPlan.individualName,
      individualName: paymentPlan.individualName,
      frequencyDay:
        frequency === this.frequencies.MONTHLY
          ? editPaymentFormValues.isSpecificDayMonth
            ? editPaymentFormValues.specificDay
            : this.weekDays.indexOf(editPaymentFormValues.weekDay)
          : this.weekDays.indexOf(editPaymentFormValues.weekDay),
      frequencyWeek:
        frequency === this.frequencies.MONTHLY
          ? !editPaymentFormValues.isSpecificDayMonth
            ? this.monthDaysWeeks.indexOf(editPaymentFormValues.monthDaysWeek) +
            1
            : 0
          : 1,
      sendPaymentLinkEmail:
        paymentPlan.email || editPaymentFormValues.sendPaymentLinkEmail,
      openPayment: Number(paymentPlan.openPayment?.toFixed(2) || 0),
      basedOnDuration: durationOrAmount === 'DURATION' ? true : false,
      isSpecificDay:
        editPaymentFormValues.isSpecificDay === false ? false : true,
      specificRelativeDay: editPaymentFormValues.specificRelativeDay || 1,
      pmsPaymentType: Number(editPaymentFormValues.pmsPaymentType || 0),
      pmsPaymentTypeName: editPaymentFormValues.pmsPaymentTypeName || '',
      isDigitalCopySaved: paymentPlan.isDigitalCopySaved || false,
      nextPaymentDate: paymentPlan.nextPaymentDate,
      lastPaymentDate: paymentPlan.lastPaymentDate,
      paymentMadeSoFar: paymentPlan.paymentMadeSoFar,
      isDirect: true,
      noOfRemainingInstallments: paymentPlan.noOfRemainingInstallments,
    };
    return previewPaymentPlan;
  }

  validateSpecificDayOfMonth(form: FormGroup, name?: string) {
    name = name || 'specificDay';
    if (form.value[name] > 28) {
      form.get(name)?.setValue(28);
    } else if (form.value[name] < 1) {
      form.get(name)?.setValue(1);
    }
  }

  setPrimaryCardValues(
    form: FormGroup,
    creditCardsByExpDate: TokenByExpDate,
    ACHDirectDebitCardsByExpDate: TokenByExpDate
  ) {
    let paymentFormValues = form.value;
    let card =
      creditCardsByExpDate.active.find(
        (x) => x.tokenId.toString() === paymentFormValues.primaryCard
      ) ||
      creditCardsByExpDate.expiringSoon.find(
        (x) => x.tokenId.toString() === paymentFormValues.primaryCard
      ) ||
      ACHDirectDebitCardsByExpDate.active.find(
        (x) => x.tokenId.toString() === paymentFormValues.primaryCard
      );
    form
      .get('primaryCardNumber')
      ?.setValue(card?.lastFourDigits || card?.accountNumber);
    form.get('primaryCardType')?.setValue(card?.tokenType);
    form.get('primaryCardGroup')?.setValue(card?.cardType);
  }

  setSecondaryCardValues(
    form: FormGroup,
    creditCardsByExpDate: TokenByExpDate,
    ACHDirectDebitCardsByExpDate: TokenByExpDate
  ) {
    let paymentFormValues = form.value;
    let card =
      creditCardsByExpDate.active.find(
        (x) => x.tokenId.toString() === paymentFormValues.secondaryCard
      ) ||
      creditCardsByExpDate.expiringSoon.find(
        (x) => x.tokenId.toString() === paymentFormValues.secondaryCard
      ) ||
      ACHDirectDebitCardsByExpDate.active.find(
        (x) => x.tokenId.toString() === paymentFormValues.secondaryCard
      );
    form
      .get('secondaryCardNumber')
      ?.setValue(card?.lastFourDigits || card?.accountNumber);
    form.get('secondaryCardType')?.setValue(card?.tokenType);
    form.get('secondaryCardGroup')?.setValue(card?.cardType);
  }
  getACHLastFourDigits(accountNumber: string): string {
    if (!accountNumber) return '****';
    return accountNumber.length >= 4
      ? accountNumber.slice(-4)
      : accountNumber.padStart(4, '*');
  }

  setInitialPaymentValues(
    form: FormGroup,
    creditCardsByExpDate: TokenByExpDate,
    ACHDirectDebitCardsByExpDate: TokenByExpDate,
    chargeTodayPayment: SchedulePayment
  ) {
    let paymentFormValues = form.value;
    let card =
      creditCardsByExpDate.active.find(
        (x) => x.tokenId.toString() === paymentFormValues.existingCard
      ) ||
      creditCardsByExpDate.expiringSoon.find(
        (x) => x.tokenId.toString() === paymentFormValues.existingCard
      ) ||
      ACHDirectDebitCardsByExpDate.active.find(
        (x) => x.tokenId.toString() === paymentFormValues.existingCard
      );
    form.get('existingCardType')?.setValue(card?.tokenType);
    chargeTodayPayment.paymentMethod = paymentFormValues.selectedPaymentOption;
    if (card?.tokenType === 1) {
      chargeTodayPayment.lastFourDigit = card.lastFourDigits || '****';
      chargeTodayPayment.cardType = card.cardType || '';
    } else if (card?.tokenType === 2) {
      const accountNumber = card.accountNumber || '';
      chargeTodayPayment.lastFourDigit =
        this.getACHLastFourDigits(accountNumber);
      chargeTodayPayment.cardType = 'ACH';
    }
    form.get('existingCardNumber')?.setValue(chargeTodayPayment.lastFourDigit);
    form.get('existingCardGroup')?.setValue(card?.cardType);
    form.get('existingCardBankName')?.setValue(card?.bankName);
    form.get('existingCardIndividualName')?.setValue(card?.individualName);
  }

  validateAmountAndDuration(
    frequency: string,
    form: FormGroup,
    paymentPlanValues: any
  ) {
    if (frequency == this.frequencies.WEEKLY && form.value.duration > 52) {
      form.get('duration')?.setValue(52);
      this.durationChanged(frequency, form, paymentPlanValues);
    }
    if (frequency == this.frequencies.MONTHLY && form.value.duration > 12) {
      form.get('duration')?.setValue(12);
      this.durationChanged(frequency, form, paymentPlanValues);
    }
    if (
      Number(form.value.installmentAmount || 0) >
      Number(paymentPlanValues?.remainingPaymentPlanAmt || 0)
    ) {
      form
        .get('installmentAmount')
        ?.setValue(
          Number(paymentPlanValues?.remainingPaymentPlanAmt || 0).toFixed(2)
        );
      this.installmentAmountChanged(frequency, form, paymentPlanValues);
    }
  }

  durationChanged(frequency: string, form: FormGroup, paymentPlanValues: any) {
    form
      .get('installmentAmount')
      ?.setValue(
        Number(
          Number(
            Number(paymentPlanValues?.remainingPaymentPlanAmt || 0) /
            Number(form.value.duration || 1)
          ) || 0
        ).toFixed(2)
      );
    this.validateAmountAndDuration(frequency, form, paymentPlanValues);
  }

  renderToFixed(value: string) {
    return isNaN(Number(value))
      ? 0
      : Number(value || 0) % 1 === 0
        ? Number(value || 0)
        : Number(value || 0)?.toFixed(2);
  }

  installmentAmountChanged(
    frequency: string,
    form: FormGroup,
    paymentPlanValues: any
  ) {
    //form
    //  .get('duration')
    //  ?.setValue(
    //   Math.floor(
    //      Number(
    //        Number(paymentPlanValues?.remainingPaymentPlanAmt || 0) /
    //        Number(form.value.installmentAmount || 1) || 0
    //      )
    //    )
    //  );
    this.validateAmountAndDuration(frequency, form, paymentPlanValues);
  }

  handleFileButtonClick(hiddenFileInput: any) {
    hiddenFileInput &&
      hiddenFileInput.nativeElement &&
      hiddenFileInput.nativeElement.click();
  }

  preparePaymentPlan(
    form: FormGroup,
    customerId: number,
    practiceId: number,
    patientId: number,
    providerId: number,
    frequency: string,
    schedulePaymentList: SchedulePayment[],
    paymentPlanValues: any,
    previewOnly: boolean,
    isDigitalCopySaved: boolean,
    selectedPaymentPlan: PaymentPlanPatient,
    durationOrAmount: string,
    isPlanChanged: boolean,
    patientSummary: PatientSummary,
    isPaymentMethodChanged: boolean
  ) {
    let paymentPlan: PaymentPlan = new PaymentPlan();
    let paymentFormValues = form.value;
    paymentPlan = {
      paymentPlanId: selectedPaymentPlan?.paymentPlanId || 0,
      customerId: Number(customerId),
      practiceId: Number(practiceId),
      patientId: Number(patientId),
      providerId: Number(providerId),
      email:
        selectedPaymentPlan?.email ||
        paymentFormValues?.sendPaymentLinkEmail ||
        '',
      phone:
        paymentFormValues?.sendPaymentLinkPhone ||
        patientSummary.cellPhone ||
        '',
      planName: paymentFormValues?.name || paymentFormValues?.planName || '',
      individualName:
        selectedPaymentPlan?.individualName ||
        paymentFormValues?.individualName ||
        (patientSummary.firstName?.trim() || '') +
        (patientSummary.lastName?.trim() && ' ') +
        (patientSummary.lastName?.trim() || '') ||
        '',
      startDate: this.formatClearantDate(
        paymentFormValues?.startingInstallmentDate ||
        this.formatDate(new Date().toString())
      ),
      frequency: frequency,
      frequencyDay:
        frequency === this.frequencies.MONTHLY
          ? paymentFormValues?.isSpecificDayMonth
            ? paymentFormValues?.specificDay
            : this.weekDays.indexOf(paymentFormValues?.weekDay)
          : this.weekDays.indexOf(paymentFormValues?.weekDay),
      frequencyWeek:
        frequency === this.frequencies.MONTHLY
          ? !paymentFormValues?.isSpecificDayMonth
            ? this.monthDaysWeeks.indexOf(paymentFormValues?.monthDaysWeek) + 1
            : 0
          : 1,
      // frequencyMonth: this.frequency === this.frequencies.MONTHLY ? 1 : 0,
      tokenId: Number(paymentFormValues?.primaryCard),
      secondaryTokenId: Number(paymentFormValues?.secondaryCard),
      paymentPlanTemplateId: Number(
        selectedPaymentPlan?.paymentPlanTemplateId || 0
      ),
      templateName: selectedPaymentPlan?.templateName || '',
      installment: Number(schedulePaymentList?.[0]?.amount || 0),
      totalAmount: Number(
        selectedPaymentPlan?.totalAmount ||
        paymentPlanValues?.paymentPlanAmt ||
        0
      ),
      initialAmount: Number(
        selectedPaymentPlan?.initialAmount ||
        paymentPlanValues?.todayPaymentAmt ||
        0
      ),
      noOfInstallments: Number(schedulePaymentList?.length || 0),
      previewOnly,
      isDigitalCopySaved: isDigitalCopySaved || false,
      openPayment:
        Number(selectedPaymentPlan?.openPayment?.toFixed(2) || 0) ||
        Number(paymentPlanValues?.remainingPatientPortion?.toFixed(2) || 0) ||
        0,
      basedOnDuration: durationOrAmount === 'DURATION' ? true : false,
      isPlanChanged,
      specificRelativeDay: paymentFormValues?.specificRelativeDay || 1,
      isPaymentMethodChanged,
      patientName: patientSummary.firstName + " " + patientSummary.lastName,
      isSendReminder: paymentFormValues?.isSendReminder
    };
    return paymentPlan;
  }

  // for input type=number
  validateFloatValue(event: any) {
    const charCode = event.which || event.keyCode;
    // char code of +,-,e
    if (charCode === 43 || charCode === 45 || charCode === 101) {
      event.preventDefault();
    }
  }

  // for input type=text
  validateNumberValue(event: any) {
    const charCode = event.which || event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  validatePercentage(form: FormGroup, fieldName?: string) {
    let percentage = fieldName ? form.value[fieldName] : form.value?.percentage;
    if (percentage < 0 || percentage >= 100) {
      form.get(fieldName || 'percentage')?.setValue(0);
    }
  }

  filterKeyUps(key: string) {
    return ['Alt', 'Control', 'AltGraph', 'Tab'].includes(key);
  }

  textTruncate(text: string, length: number) {
    return text?.length > length
      ? text?.slice(0, length) + '...'
      : text?.slice(0, length);
  }

  public findInvalidControls(form: FormGroup) {
    const invalid = [];
    const controls = form.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  public enforceTwoDecimals(event: Event) {
    const input = event.target as HTMLInputElement;
    const value = input.value;
    if (!/^\d*(\.\d{0,2})?$/.test(value)) {
      input.value = parseFloat(value).toFixed(2).toString();
    }
  }

  public formatLocaleDate(dateString: any) {
    const [datePart, timePart] = dateString.split(', ');
    const [month, day, year] = datePart.split('/');
    const [time, meridian] = timePart.split(' ');
    let [hours, minutes, seconds] = time.split(':');

    // Adjust hours for AM/PM
    hours = parseInt(hours, 10);
    if (meridian === 'PM' && hours !== 12) {
      hours += 12;
    } else if (meridian === 'AM' && hours === 12) {
      hours = 0;
    }

    // Format hours, minutes, and seconds
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.padStart(2, '0');
    const formattedSeconds = seconds.padStart(2, '0');
    const formattedDay = day.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');

    // Return the formatted string
    return `${year}-${formattedMonth}-${formattedDay}T${formattedHours}:${formattedMinutes}:${formattedSeconds}.000`;
  }

  public formatMatDateToDateTime(date: Date): string
  {
    if (!date) return '';
    const d = new Date(date); 
    const pad = (n: number) => n.toString().padStart(2, '0');

    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`
       + `T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
  }

  public noWhitespaceValidator(control: FormControl) {
    return (control.value || '')?.trim().length ? null : { whitespace: true };
  }

  public findDuplicateString(arr: any) {
    return arr.filter(
      (item: any, index: number) => item && arr.indexOf(item) !== index
    );
  }

  public findDuplicateObjects(arr: any[]) {
    const seen = new Set<string>();
    const duplicates = new Set<string>();
    arr = arr.filter((x) => x.columnName);
    for (const item of arr) {
      const key = `${item.columnName}-${item.columnType}`;
      if (seen.has(key)) {
        duplicates.add(key);
      } else {
        seen.add(key);
      }
    }

    return arr.filter((item) =>
      duplicates.has(`${item.columnName}-${item.columnType}`)
    );
  }

  groupMenusByModule(
    menuList: any,
    userRoleDetails: any,
    menuListByCustomerSubscription: any
  ) {
    let menuData = menuList.map((data: any) => {
      return {
        ...data,
        checked:
          userRoleDetails?.roleDetails &&
            userRoleDetails?.roleDetails?.find(
              (item: any) => data.menuId == item.menuId
            )
            ? true
            : false,
        menuName: data.menuName,
        displayText:
          data.type == 1
            ? data.displayText
            : data.type == 2
              ? data.displayText
              : data.type == 3
                ? data.displayText
                : data.displayText,
      };
    });

    const menuMap = new Map<number, any>();

    menuData.forEach((menu: any) => {
      if (!menuMap.has(menu.moduleId)) {
        menuMap.set(menu.moduleId, {
          moduleId: menu.moduleId,
          moduleName: menu.moduleName,
          menus: [],
        });
      }
      menuMap.get(menu.moduleId)?.menus.push(menu);
    });

    menuListByCustomerSubscription = Array.from(menuMap.values()).map(
      (module) => {
        return {
          ...module,
          menus: this.buildHierarchy(module?.menus),
        };
      }
    );
    return menuListByCustomerSubscription;
  }

  roundToNext(value: number): number {
    if (value === 0) return 0;

    const abs = Math.abs(value);
    const digits = Math.floor(Math.log10(abs));
    const base = Math.pow(10, digits - 1);

    const rounded = Math.ceil(abs / base) * base;
    return Math.sign(value) * rounded;
  }

  buildHierarchy(menus: any[]): any[] {
    const menuMap = new Map<number, any>();
    const roots: any[] = [];

    menus.forEach((menu) => {
      menuMap.set(menu.menuId, { ...menu, children: [] });
    });

    menus.forEach((menu) => {
      if (menu.parentId !== menu.menuId) {
        const parent = menuMap.get(menu.parentId);
        if (parent) {
          parent.children.push(menuMap.get(menu.menuId));
        }
      } else {
        roots.push(menuMap.get(menu.menuId));
      }
    });

    return roots;
  }

  validateEmails(emails: string[]): boolean {
    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emails.every((email) => emailPattern.test(email));
  }

  getPaymentMethodName(method: string) {
    let methods = this.generateDropdownValuesFromEnum(
      MAIN_PAYMENT_METHODS_DROPDOWN
    );
    return methods?.find((x: any) => x.value === method)?.name || '';
  }


  generateCronValues(formData: CreteCronCommand) {
    let cronValues: any = {
      seconds: "0",
      minutes: "0",
      hours: "0",
      dayOfMonth: "*",
      months: "*",
      dayOfWeek: "*",
      year: "*",
    }

    const convertedScheduleTime = this.transform12to24(formData.scheduleTime?.toString());
    const convertedScheduleEndTime = this.transform12to24(formData.scheduleEndTime?.toString());

    if (formData.loadType == LOAD_TYPE_ID.OnDemand) {
      // Do not generate Cron Value
    }
    else if (formData.loadType == LOAD_TYPE_ID.Incremental) {
      if (formData.frequencyType == FREQUENCY_TYPE_ID.OneTime) {
        cronValues.hours = convertedScheduleTime?.split(":")[0].toString();
        cronValues.minutes = convertedScheduleTime?.split(":")[1].toString();
      }
      if (formData.frequencyType == FREQUENCY_TYPE_ID.Recurring) {
        cronValues.hours = convertedScheduleTime?.split(":")[0] + "-" + convertedScheduleEndTime?.split(":")[0];
        cronValues.minutes = "0/" + formData.timeFrequency;
      }
    }
    else if (formData.loadType == LOAD_TYPE_ID.FullLoad) {
      if (formData.frequencyType == FREQUENCY_TYPE_ID.OneTime) {
        cronValues.hours = convertedScheduleTime?.split(":")[0].toString();
        cronValues.minutes = convertedScheduleTime?.split(":")[1].toString();
      }
      if (formData.frequencyType == FREQUENCY_TYPE_ID.Recurring) {
        if (formData.frequencyBy == FREQUENCY_BY_ID.Daily) {
          cronValues.hours = convertedScheduleTime?.split(":")[0].toString();
          cronValues.minutes = convertedScheduleTime?.split(":")[1].toString();
        }
        if (formData.frequencyBy == FREQUENCY_BY_ID.Weekly) {
          cronValues.hours = convertedScheduleTime?.split(":")[0].toString();
          cronValues.minutes = convertedScheduleTime?.split(":")[1].toString();
          cronValues.dayOfWeek = formData.weekDays
        }
      }
    }
    else if (formData.loadType == LOAD_TYPE_ID.InitialFullLoad) {
      cronValues.hours = convertedScheduleTime?.split(":")[0].toString();
      cronValues.minutes = convertedScheduleTime?.split(":")[1].toString();
    }

    return cronValues;
  }

  returnDate(date: Date | string): Date {
    if (!date) return new Date('');
    const d = new Date(date);
    const year = d.getFullYear();
    const month = d.getMonth();
    const day = d.getDate();
    return new Date(Date.UTC(year, month, day, 0, 0, 0));
  }

  formatExpiryMonthYear(value: string | null | undefined): string {
    if (!value) {
      return '';
    }

    // Ensure it's exactly 4 digits
    if (!/^\d{4}$/.test(value)) {
      return value; // or return '' if you want strict validation
    }

    return `${value.substring(0, 2)}/${value.substring(2, 4)}`;
  }
  validateFileSize(file: File): boolean {
    if (file.size > this.maxFileSizeBytes) {
      this._snackBarService.openSnackBar(
        `File size must not exceed ${this.maxFileSizeMB} MB.`,
        'Warn'
      );
      return false;
    }
    return true;
  }

  getToolTipMessage(row: any, cols: any,action?: any) : string{

    if (row) {
      if (cols.tooltipDescriptionType) {
        var title = cols.tooltipDescriptionType + '-' + this.prepareBagdeLabel(row,cols).replace(/\s+/g, "").trim().toLowerCase() + '-title';
        switch (title) {
          case 'status-order-created-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ORDER_CREATED;
          case 'status-order-completed-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ORDER_COMPLETED;
          case 'status-order-cancelled-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ORDER_CANCELLED;
          case 'status-payment-initiated-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.PAYMENT_INITIATED;
          case 'status-payment-success-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.PAYMENT_SUCCESS;
          case 'status-payment-failed-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.PAYMENT_FAILED;
          case 'status-writeback-pending-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.WRITEBACK_PENDING;
          case 'status-writeback-success-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.WRITEBACK_SUCCESS;
          case 'status-writeback-failed-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.WRITEBACK_FAILED;
          case 'status-writeback-duplicatetransaction-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.WRITEBACK_DUPLICATE;
          case 'status-writeback-skipped-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.WRITEBACK_SKIPPED;
          case 'status-onboarding-masteraccountcreated-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_MASTER_ACCOUNT_CREATED;
          case 'status-onboarding-ordercreated-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_ORDER_CREATED;
          case 'status-onboarding-ttaccountcreated-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_TT_ACCOUNT_CREATED;
          case 'status-onboarding-practiceactive-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_PRACTICE_ACTIVE;
          case 'status-onboarding-agreementaccepted-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_AGREEMENT_ACCEPTED;
          case 'status-onboarding-configuredpms-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_CONFIGURED_PMS;
          case 'status-onboarding-processorsetupcompleted-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.ONBOARDING_PROCESSOR_SETUP_COMPLETED;
          case 'status-invoice-paid-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.INVOICE_PAID;
          case 'status-invoice-due-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.INVOICE_DUE;
          case 'status-invoice-overdue-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.INVOICE_OVERDUE;
          case 'status-invoice-voided-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.INVOICE_VOIDED;
          case 'status-invoice-refunded-title':
            return TOOLTIP_DISCRIPTION_MESSAGES.STATUS.INVOICE_REFUNDED;
          default:
            return '';
        }
      }
      if(action)
      {
        switch(action.tooltipDescriptionType)
        {
          case 'action-wb-retry':
            return TOOLTIP_DISCRIPTION_MESSAGES.ACTIONS.WRITEBACK_RETRY;
          case 'action-wb-skip':
            return TOOLTIP_DISCRIPTION_MESSAGES.ACTIONS.WRITEBACK_SKIP;
          case 'action-wb-proceed':
            return TOOLTIP_DISCRIPTION_MESSAGES.ACTIONS.WRITEBACK_PROCEED;
          case 'action-refund-settlement':
            return TOOLTIP_DISCRIPTION_MESSAGES.ACTIONS.REFUND_SETTLEMENT;
          default:
            return '';
        }
      }
    }
    return ''
  }
  getModuleLabel(item: any): string {
      const label = (item.value || '').replaceAll('_', ' ');
      return item.name === MODULES.AR_AUTOMATION
        ? label.replace(/\bAR\b/i, 'A/R')
        : label;
    }
  toDateOnly(value: any): Date | null {
    if (!value) return null;
    const d = new Date(value);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()); 
  }

  daysBetween(from: Date, to: Date): number {
    const MS_PER_DAY = 24 * 60 * 60 * 1000;
    return Math.round((to.getTime() - from.getTime()) / MS_PER_DAY); 
  }
}
